import React, { PureComponent } from 'react';

import { PieChart, Pie, Cell } from 'recharts';
import { Error } from "./../../Utils/Utils.js"
import numeral from '../../../../node_modules/numeraljs/numeral.js';

const CLICK_COLORS = [
  '#16C8DE',
  '#f4f4f4'
];

class Chart extends PureComponent {

  render() {
    return (
      <span className="piechart-wrapper">
        {
          <PieChart height={38}>

            <Pie dataKey="value" data={this.props.data.data} outerRadius="100%" innerRadius="70%">
              {
                this.props.data.data.map((entry, index) => (
                  <Cell key={`cell-${entry}`} fill={CLICK_COLORS[index]} />
                ))
              }
            </Pie>
            <text x="50%" y="50%" textAnchor="middle" dominantBaseline="middle" className="piechart-metric__small">
              {numeral(this.props.data.data[0].value).divide(100).format('%')}
            </text>

          </PieChart>
        }
      </span>
    )
  }
}

class Label extends PureComponent {

  render() {

    return (
      <span className="piecharts-label-wrapper">
        {
          this.props.data.map((chart, key) => (
            <span key={key} className="table-with-content__piecharts">
              {chart.newsletter}
              <Chart data={chart} />
            </span>
          ))
        }
      </span>
    )
  }
}

class NewslettersTopLinks extends PureComponent {
  renderRows(data) {
    return data.data.map(function (row, key) {
      return <tbody key={key}>
        <tr>
          <td className="text-left pb-0">
            <span className="table-with-content__text">
              <span className="table-with-content__link">
                <a href={row.link} target="_blank" rel="noopener noreferrer">{row.link.split('?')[0]}</a>
              </span>
            </span>
          </td>
          <td className="text-left">{numeral(row.views).format('0.0a')}</td>
          <td className="text-center text-green">{numeral(row.clicks).format('0.0a')}</td>
          <td className="text-center">{numeral(row.ctr).format('0.0')}%</td>
        </tr>
        <tr>
          <td colSpan="4" className="pt-2">
            <span className="table-mini-piechart-wrapper">
              <span className="text-muted">Clicked From:&nbsp; </span> <Label data={row.charts} />
            </span>
          </td>
        </tr>
      </tbody>;
    });
  }

  render() {
    let { data } = this.props;
    
    if (data.hasData === false) {
      return <Error minHeight={360} />
    }

    return (
      <div className="react-bs-table-container">
        <table className="table-with-content table-responsive">
          <thead>
            <tr>
              <th className="text-left pl-0">Link</th>
              <th className="text-left pl-0">Views</th>
              <th>Clicks</th>
              <th>CTR</th>
            </tr>
          </thead>
          {this.renderRows(data)}
        </table>
      </div>
    );
  }
}


export default NewslettersTopLinks
